
import { Component, Vue, Prop } from "vue-property-decorator";
import Pop from "../components/blue-pop.vue";
import InputNumberV3 from "@/views/ai-builder-v3/components/inputNumberV3.vue";
import IntroduceCard from "@/views/ai-builder-component/components/introduce-card.vue";
import HinaSwitch from "../baseComponent/hina-switch.vue";
import { ExamVersionInfo } from "@/lib/model/exambuilder/exam-component/exam";
import { Param } from "@/lib/model/exambuilder/exam-component/params";

/**
 *enumBgCheckProductId1 = 1 // 身份认证【三要素】
  enumBgCheckProductId2 = 2 // 身份认证【三要素】+社会安全
  enumBgCheckProductId3 = 3 // 身份认证【三要素】+金融
  enumBgCheckProductId4 = 4 // 身份认证【三要素】+社会安全+金融

  // enumBgCheckProductId5 = 5 // 身份认证【二要素】
  enumBgCheckProductId6 = 6 // 身份认证【二要素】+社会安全
  enumBgCheckProductId7 = 7 // 身份认证【二要素】+金融
  enumBgCheckProductId8 = 8 // 身份认证【二要素】+社会安全+金融
  */
// 111 -》 【身份认证、社会安全、金融】
const enumBgCheckProductId = {
  "000": 0,
  "100": 1,
  "110": 2,
  "101": 3,
  "111": 4,
  "010": 6,
  "001": 7,
  "011": 8,
  0: "000",
  1: "100",
  2: "110",
  3: "101",
  4: "111",
  6: "010",
  7: "001",
  8: "011"
};

@Component({
  components: {
    Pop,
    InputNumberV3,
    IntroduceCard,
    HinaSwitch
  }
})
export default class FaceCheck extends Vue {
  @Prop() formItemData!: ExamVersionInfo; // 组件数据
  @Prop({ default: "" }) builder!: string; // 创建面试来源

  rules = {};

  socialSecurity = 1; // 社会安全
  finance = 1; // 金融
  identity = 1; // 身份认证

  change() {
    console.log(this.formItemData, "asdas");
  }

  beforeChange() {
    if (this.builder === "MOKA_V2") {
      return this.$message.warning("请联系你的顾问开通后才可开启");
    }
  }

  calcProduceId() {
    let productCode = "";
    productCode += this.identity === 1 ? "1" : "0";
    productCode += this.socialSecurity === 1 ? "1" : "0";
    productCode += this.finance === 1 ? "1" : "0";
    const productId = enumBgCheckProductId[productCode];
    this.formItemData.bgCheck.configData.bgCheckProductId = productId;
    this.formItemData.bgCheck.use = productId === 0 ? 2 : 1;

    if (productId === 0) return;

    this.formItemData.params.use = 1;
    this.formItemData.allParams.forEach(item => {
      if (!["姓名", "手机", "身份证号"].includes(item.name)) return;

      const select = this.formItemData.paramList.find(
        sItem => sItem.name === item.name
      );

      if (select) {
        // 开启背调，不需要开启验证码，因为登录的时候已经输入验证码了
        select.captchaCheck = 0;
        select.isRequired = 1;
        select.isShow = 1;
        select.saveLater = 0;
        select.showConfigList = [];
        return;
      }
    });
  }

  // 校验数据：
  //    (1) 校验不通过，返回 false
  //    (2) 校验通过，返回 true
  formItemCheck() {
    return new Promise((resolve, reject) => {
      const valid = true;
      if (valid) {
        resolve("");
      } else {
        resolve("AiAnswer");
      }
    });
  }

  mounted() {
    console.log(this.formItemData.bgCheck.configData.bgCheckProductId);
    const productCode =
      enumBgCheckProductId[
        this.formItemData.bgCheck.configData.bgCheckProductId
      ];
    this.identity = Number(productCode[0]) === 1 ? 1 : 2;
    this.socialSecurity = Number(productCode[1]) === 1 ? 1 : 2;
    this.finance = Number(productCode[2]) === 1 ? 1 : 2;
  }
}
